import setedigitalApi from "./api/setedigitalApi";
import {
  INotificationsResponse,
  IUnreadNotificationsResponse,
} from "types/notification";

export const getNotifications = async ({
  page = 1,
  limit = 10,
  unread,
}: {
  page?: number;
  limit?: number;
  unread?: boolean;
}) => {
  const response = await setedigitalApi.get<INotificationsResponse>(
    "/notification/readAll",
    {
      params: {
        page,
        limit,
        ...(unread ? { unread: true } : {}),
      },
    }
  );

  return response.data;
};

export const getUnreadNotificationsCount = async () => {
  const response = await setedigitalApi.get<IUnreadNotificationsResponse>(
    "/notification/unreadCount"
  );

  return response.data;
};

export const markNotificationAsRead = async (id: string) => {
  const response = await setedigitalApi.patch(`/notification/read/${id}`);
  return response.data;
};

export const removeNotification = async (id: string) => {
  const response = await setedigitalApi.patch(`/notification/remove/${id}`);
  return response.data;
};

export const clearNotifications = async () => {
  const response = await setedigitalApi.patch("/notification/clearAll");
  return response.data;
};
